import request from '@/request/request'

// 查询字典数据列表
export function listData(query) {
  return request({
    url: '/api/system-server/sysDictData/list',
    method: 'get',
    params: query
  })
}

// 查询字典数据详细
export function getData(dictCode) {
  return request({
    url: '/api/system-server/sysDictData/' + dictCode,
    method: 'get'
  })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/api/system-server/sysDictData/list',
    method: 'get',
    params: { dictType: dictType }
  })
}

// 新增字典数据
export function addData(data) {
  return request({
    url: '/api/system-server/sysDictData',
    method: 'post',
    data: data
  })
}

// 修改字典数据
export function updateData(data) {
  return request({
    url: '/api/system-server/sysDictData/edit',
    method: 'post',
    data: data
  })
}

// 删除字典数据
export function delData(dictCode) {
  return request({
    url: '/api/system-server/sysDictData/delete/' + dictCode,
    method: 'post'
  })
}
